// removed by extract-text-webpack-plugin
module.exports = {"block":"_1XNO0P1cX4d1PgHTekw8dL","heading":"_3z0XVBeRuxxp68IpK4UBx","zebra":"xEHbzwaQOpFDhSpI5Jgyv","yellow":"_34o350Hz0124TPox7z4MTO","darkgray":"_3Yk9w05WEN4EHMtxIcnwsn","lightgray":"C6biZC4Va_eDHK_GS2mIv","white":"_3Sb79fixavNNhbXsomOLsB","content":"_3xK0xqVhNx2tQJ8jJJqi2","is-on-screen":"_2jeERY6XkEPQh9N8Aq7GOg","see-all":"_3jL989gvT_bIJifY_Nx6T"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VacancyListBlock/VacancyListBlock.module.scss
// module id = 814
// module chunks = 0